module.exports = __webpack_public_path__ + "img/TjaKeinStrand.9b8b2c30.jpg";